"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isVideoMarkerProperty = exports.videoMarkerPropertyDefinition = void 0;
exports.videoMarkerPropertyDefinition = {
    name: 'video-marker',
    type: 'ordered-container',
    multiple: true,
    view: { label: 'Video marker' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'video-marker-timestamp',
                'video-marker-title',
                'video-marker-link',
            ],
        },
    ],
};
const isVideoMarkerProperty = (prop) => {
    return prop.name === exports.videoMarkerPropertyDefinition.name;
};
exports.isVideoMarkerProperty = isVideoMarkerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tbWFya2VyLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdmlkZW8tbWFya2VyLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLGNBQWM7SUFDcEIsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxjQUFjLEVBQUU7SUFDL0IsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRTtnQkFDUix3QkFBd0I7Z0JBQ3hCLG9CQUFvQjtnQkFDcEIsbUJBQW1CO2FBQ3BCO1NBQ0Y7S0FDRjtDQUM4QixDQUFBO0FBSTFCLE1BQU0scUJBQXFCLEdBQUcsQ0FBQyxJQUFrQixFQUErQixFQUFFO0lBQ3ZGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxxQ0FBNkIsQ0FBQyxJQUFJLENBQUE7QUFDekQsQ0FBQyxDQUFBO0FBRlksUUFBQSxxQkFBcUIseUJBRWpDIn0=